import { createFileRoute } from '@tanstack/react-router';
import { Stack, Text, Title } from '@mantine/core';

function Terms() {
  return (
    <Stack gap="md">
      <Title order={2}>Terms of Service</Title>
      <Text>
        By signing in to LeadSync you agree to comply with Meta's Platform Terms and the WhatsApp
        Business Solution Terms applicable to the WABA you connect.
      </Text>
      <Text fw={600}>Acceptable use</Text>
      <Text>
        You agree not to use LeadSync to send unsolicited messages, to impersonate other businesses,
        or to violate Meta's content policies. We reserve the right to suspend or terminate any
        account that risks the platform's standing with Meta.
      </Text>
      <Text fw={600}>Changes</Text>
      <Text>
        We may update these terms from time to time. Material changes will be communicated via
        in-app notification.
      </Text>
    </Stack>
  );
}

export const Route = createFileRoute('/legal/terms')({ component: Terms });
